import { useSelector } from 'react-redux'
import { RootState } from '../redux'
import { Sector } from '../types'

export default function useSectors(): Sector[] {
  return useSelector((state: RootState) => state.sectors.sectors)
}
